import request from '@/utils/request'
const apiPath = '/lecturer/lecturerLevel'
const sysDataconstantApi = {
  /**
   * 新增【讲师等级】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【讲师等级】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【讲师等级】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  /**
   * 查看【讲师等级】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【讲师等级】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
}
export default sysDataconstantApi
